import React from 'react';
import NavigationMenuEUWeb from '../../../components/src/NavigationMenuEU.web';
import { Avatar, Box, Button, Grid, InputAdornment, TextField, Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import WallpaperIcon from '@material-ui/icons/Wallpaper';
import CheckIcon from '@material-ui/icons/Check';
import MobileNavEndUser from '../../dashboard/src/MobileNavEndUser.web';
import SuggestedBrands from '../../../components/src/SuggestedBrands';
import Rating from '@material-ui/lab/Rating';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import PostCreationCommonController from './PostCreationCommonController';
import CustomLoader from '../../../components/src/CustomLoader.web';
import { styled } from "@material-ui/core/styles";
import TopActiveUsersEU from '../../dashboard/src/TopActiveUsersEu.web';

const RootBox = styled(Box)(({theme}) => ({
  backgroundColor: "#f1f4f9",
  [theme.breakpoints.down(768)]: {
    backgroundColor: "#fff",
  },
  "& .contentGridContainer":{
    backgroundColor: "#FFFFFF",
    borderRadius: '4px',
    [theme.breakpoints.down(768)]: {
      width: "100%"
    },
  },
  "& .topAndSuggestedBrand":{
    [theme.breakpoints.down(960)]: {
      display: "none"
    },
  },
  "& .hr":{
    height: "1px",
    width: "100%",
    background: '#64748B33'
  },
  "& .headerText":{
    fontSize: "24px",
    fontWeight: 700,
    color: "#000",
    [theme.breakpoints.down(768)]: {
      fontSize: "20px"
    },
  },
}))

const CreateWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent:"center",
  flexDirection: "column",
})

const CreateInnerWrapper = styled(Box)(({theme}) => ({
  height: "200px",
  width: "200px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down(480)]: {
    height: "109px",
    width: "109px"
  },
  "& .wallpaperIcon":{
    fontSize: "55px",
    [theme.breakpoints.down(480)]: {
      fontSize: "34px"
    },
  },
  "& .starRating":{
    fontSize: "",
    [theme.breakpoints.down(480)]: {
      fontSize: "14px"
    },
  }
}))

const ContentBox = styled(Box)(({theme}) => ({
  margin: "35px 20px 64px 20px",
  [theme.breakpoints.down(768)]: {
    margin: "15px 15px 64px 15px",
  },
}))

export default class PostCreationEu extends PostCreationCommonController {

  avatarRender(profile: {url : string} | null , index: number) {
    return (<Avatar src={profile ? profile.url : `https://avatar.iran.liara.run/public/${index+1}`} style={index < this.state.brands.length ? webStyle.brandLogo : webStyle.brandLogoInactive} />)
  }

  render() {
    const { navigation } = this.props
    const { top6CreatePost } = this.state

    return (
      <RootBox>
        <NavigationMenuEUWeb brands={this.state.brandsIFollowCreate}/>
        <Box style={webStyle.mainContainer}>
          <Grid container style={webStyle.gridContainer} >
            <Grid item sm={12} md={8} className='contentGridContainer'>

              <ContentBox>
                <Box>
                {
                  this.state.euCreateLoading ? <CustomLoader loaderSize={24} isLoading={this.state.euCreateLoading} /> :
                  <>
                  {
                    this.state.eupoststep === 1 && 
                    <>
                      <Typography className='headerText'>
                        Where would you like to post?
                      </Typography>
                      <Box className='hr' style={{margin: "6px 0 24px 0"}}/>
                      <Box style={webStyle.searchBox}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder={this.state.selectedBrand.length === 0 ? "Search" : `Selected: ${this.state.selectedBrand.map(elem => elem.name).join(" - ")}`}
                          style={webStyle.searchInput}
                          InputProps={{
                            style: { borderRadius: '98px' },
                            startAdornment: (
                              <InputAdornment position="start">
                                {
                                  this.state.selectedBrand.length === 0 ? <SearchIcon style={webStyle.searchIcon} /> : ''
                                }

                              </InputAdornment>
                            ),
                            // classes: { input: webStyle.textFieldPadding }
                          }}
                          data-test-id="txtInputSearch"
                          onChange={(e)=>this.SearchValue(e.target.value)}
                        />

                      </Box>
                    
                      <Grid  container spacing={2} style={webStyle.brandGrid}>
                        {
                          [...this.state.brands, ...this.state.suggestedBrandsCreate].length > 0 ? 
                          <>
                            {
                            [...this.state.brands, ...this.state.suggestedBrandsCreate].map((brand, index) => {
                              const name = brand.attributes.first_name + " " + brand.attributes.last_name
                              const profile = brand.attributes.profile_pic
                              return(
                              <Grid item xs={6} sm={4} md={4} lg={3}  key={index}>
                                <Box style={webStyle.brandBox}
                                  onClick={this.handleBrandSelection.bind(this, {id: brand.id ,name}, index)}
                                >
                                  <Avatar
                                    src={profile ? profile.url : `https://avatar.iran.liara.run/public/${index+1}`}
                                    style={
                                      index < this.state.brands.length
                                        ? { ...webStyle.brandLogo, border: `2px solid ${this.state.postThemeColor1}` }
                                        : webStyle.brandLogoInactive
                                    }
                                  />
                                  <Typography style={webStyle.brandName}>{name}</Typography>
                                  {this.state.selectedBrand.some(elem => elem.id === brand.id) && <Box style={{width: "35px", height: "35px", position: "absolute", top: "25%", left: "42%"}}><CheckIcon style={{fontSize:"30px"}}/></Box>}
                                </Box>
                              </Grid>
                            )})}
                            <Grid item xs={12} lg={12} style={webStyle.continueWrapper}>
                            <Button 
                              variant="contained" 
                              data-test-id="continue-button" 
                              style={{ ...webStyle.continue, backgroundColor: this.state.postThemeColor1 }} 
                              onClick={this.handleContinue.bind(this)}
                              disabled={this.state.selectedBrand.length === 0}
                            >
                              <CheckIcon style={{marginRight:"8px"}}/> Continue
                            </Button>
                            </Grid>
                          </>
                            :
                            <Box>
                              Can't find any data
                            </Box>
                        }
                      </Grid>
                    </>
                  }
                  {
                    this.state.eupoststep === 2 &&
                    <>
                      <Box display="flex" alignItems="center" style={{gap: '12px'}}>
                        <Box data-test-id="back-button" style={webStyle.arrowIconContainer} onClick={this.SetEuPoststep.bind(this, this.state.eupoststep-1)}>
                          <ArrowBackIosOutlinedIcon />
                        </Box>
                        <TextField
                          fullWidth
                          variant="outlined"
                          disabled
                          InputProps={{style: { borderRadius: '98px' }}}
                          style={webStyle.searchInput}
                          placeholder={`Selected: ${this.state.selectedBrand.map(elem => elem.name).join(" - ")}`}
                        />
                      </Box>
                      <Box>
                      <Typography className='headerText' style={{margin: "16px 0"}}>What would you like to post?</Typography>
                      <Box className='hr' style={{marginBottom: "12px"}}/>

                      </Box>
                      <Grid container spacing={3} justifyContent="center">
                        <Grid item xs={6}>
                          <CreateWrapper>
                            <CreateInnerWrapper style={{ ...webStyle.createPostInnerWrapper, backgroundColor: this.state.postThemeColor1 }}>
                              <WallpaperIcon className='wallpaperIcon'/>
                            </CreateInnerWrapper>
                            <Typography data-test-id="create-new-post" variant='h6' style={webStyle.createPostText}>
                              Create New Post
                            </Typography>
                          </CreateWrapper>
                        </Grid>
                        <Grid item xs={6}>
                          <CreateWrapper>
                            <CreateInnerWrapper style={webStyle.leaveReviewContainer}>
                              <Rating
                                name="size-large" 
                                defaultValue={2}
                                className='starRating'
                                value={this.state.starRating}
                                style={{ color: this.state.postThemeColor1 }}
                                data-test-id="RatingChange"
                                onChange={(event, newValue) => {
                                  this.ChangeRating(newValue);
                                }}
                              />
                            </CreateInnerWrapper>
                            <Typography variant='h6' style={webStyle.createPostText}>
                              Leave a Review
                            </Typography>
                          </CreateWrapper>
                          {this.state.reviewResult && (
                            <Typography style={{ color: "red" }}>
                              {this.state.reviewResult}
                            </Typography>
                          )}
                          {this.state.reviewMessage && (
                            <Typography style={{ color: "black",display:"flex",justifyContent:"center",width:"100%" }}>
                              {this.state.reviewMessage}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>
                    </>
                  }
                  </>
                }
                </Box>
              </ContentBox>
            </Grid>
            <Grid item xs={12} sm={12} md={3} className='topAndSuggestedBrand'>
              <Box>
                <TopActiveUsersEU
                  top6={top6CreatePost}
                  navigation={navigation}
                />
              </Box>
              <Box>
                <SuggestedBrands
                  brands={this.state.suggestedBrandsCreate}
                  followBrand={this.followBrandPostApi}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <div>
        <MobileNavEndUser navigation={navigation} />
      </div>
      </RootBox>
    );
  }
}


const webStyle = {
  mainContainer: {
    margin: "15px auto",
    maxWidth: "1240px",
  },
  gridContainer: {
    marginTop: '10px',
    gap: '15px',
    backgroundColor: "#f1f4f9",
    justifyContent: "center"
  },
  gridItem: {
    backgroundColor: "#FFFFFF",
    borderRadius: '4px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    minWidth: '100%',
  },
  contentBox: {
    margin: "35px 15px 20px 50px",
  },
  fontinfo: {
    fontWeight: 700,
    color: "#000000",
    marginBottom: '16px',
    borderBottom: "1px solid #64748B33",
    paddingBottom: '16px',
    "@media (min-width: 768px)":{
      fontWeight: "bold",
    }
  },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '24px',
    // marginLeft:'-15px'
  },
  searchIcon: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
  searchInput: {
      background: "#F7F8FC",
      borderRadius: "98px"
  },
  textFieldPadding: {
    padding: "10px"
  },
  brandGrid: {
    marginTop: '16px',
  },
  brandBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: "relative"
  } as React.CSSProperties,
  brandLogo: {
    width: '64px',
    height: '64px',
    border: `2px solid #FFC629`,
    padding: '8px',
    cursor: "pointer"
  },
  brandLogoInactive: {
    width: '64px',
    height: '64px',
    border: `2px solid grey`,
    padding: '8px',
    cursor: "pointer",
    opacity: "0.5",
    filter: "grayscale(80%)",
    transition: "opacity 0.3s ease, filter 0.3s ease"
  },
  "& .MuiBottomNavigationAction-label": {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "20px",
      fontFamily: "Inter, 'sans-serif'",
    },
    "& .MuiBottomNavigationAction-wrapper": {
      height: "58px",
      width: "58px",
      borderRadius: "50%",
      backgroundColor: "#FFC629",
    },
  brandName: {
    marginTop: '8px',
    textAlign: 'center',
    color: "#334155",
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: '16px',
  } as React.CSSProperties,
  continue: {
    backgroundColor: "#FFC629",
    textTransform: "capitalize" as "capitalize",
    padding: "10px 16px",
    width: "132px",
    color: 'black',
    fontWeight: 700,
    borderRadius: "8px",
    gap: "8px",
    boxShadow: "none",
    justifyContent: "flex-start",
    "& span": {
      fontSize: "16px",
      fontWeight: 700,
      fontFamily: "Inter, 'sans-serif'"
    },
    "&:hover": {
      backgroundColor: "#FFC629",
      boxShadow: "none",
    }
  },
  continueWrapper:{
    display:"flex",
    justifyContent: "flex-end",
    padding: "30px 35px 10px"
  },
  createPostInnerWrapper: {
    backgroundColor: "#FFC629",
  },
  leaveReviewContainer: {
    backgroundColor: "#000000",
  } as React.CSSProperties,
  createPostText: {
    color: "#000000",
    fontFamily: "Inter",
    fontWeight: 700,
    lineHeight: "32px",
    fontSize: "18px",
    marginTop: "10px"
  },
  arrowIconContainer: {
    width: "24px",
    height: "24px",
    textAlign: "center",
    borderRadius: "50%",
    padding: "5px",
    border: "1px solid #000",
    cursor:"pointer"
  } as React.CSSProperties
}